<template>
  <div>
    <user-warning-message :users="warningMessages"/>
    <section>
      <informations-general
        :regroupementProduit="regroupementProduit"
        :detail="detail"/>
    </section>
    <section>
      <informations-produits
        :regroupementProduit="regroupementProduit"
        :detail="detail"/>
    </section>
  </div>
</template>

<script>
import InformationsGeneral from '@/components/presse/regroupementProduit/informations/informationsGeneral';
import InformationsProduits from '@/components/presse/regroupementProduit/informations/informationsProduits';
import userWarningMessage from '@/components/commun/user/userWarningMessage';

export default {
  name: 'InformationsIndex',
  props: {
    regroupementProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    InformationsGeneral,
    InformationsProduits,
    userWarningMessage,
  },
  computed: {
    warningMessages() {
      return [
        {
          id: this.regroupementProduit.assistantId,
          msg: 'utilisateur.warning.assistantArchive',
        },
        ...this.regroupementProduit.objectifsVente.map(o => ({
          id: o.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
        ...this.regroupementProduit.commissionsVendeur.map(c => ({
          id: c.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
      ];
    },
  },
};
</script>
